export const TOTAL_ITEMS_FOR_PAGE = 15;
